export function toHex(num: number) {
  if(!num){
    return '';
  }
  // tslint:disable
  num >>>= 0;
  const b = num & 0xFF;
  const g = (num & 0xFF00) >>> 8;
  const r = (num & 0xFF0000) >>> 16;
  return '#' + [r, g, b].map((component) => { return hexToDigit(component); }).join('');
  // tslint:enable
}

function hexToDigit(num: number) { //tslint:disable-line
  let str = num.toString(16);
  if (str.length < 2) {
  str = '0' + str;
  }
  return str;
}
